__webpack_require__.p = "/react-moving-slider/";